import type { IntlShape } from 'react-intl';
import type { AppStepSpec, LocalizedText } from '@api/apps';

type Formatter = (text: LocalizedText) => string;

/** Manifest copy as react-intl wants it: the app's id, its English as the fallback. */
export const localized = (intl: IntlShape, value: LocalizedText): string =>
  intl.formatMessage({ id: value.id, defaultMessage: value.default });

/**
 * The label of the step the run last reported, for the one status line the
 * screen shows. A step the manifest does not declare reads as no label rather
 * than as raw id: the ids are an internal contract with the agent, not copy.
 */
export const stepLabelFor = (
  specs: readonly AppStepSpec[],
  stepId: string | null,
  format: Formatter,
): string | null => {
  if (!stepId) return null;
  const spec = specs.find((candidate) => candidate.id === stepId);
  return spec ? format(spec.label) : null;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
